/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Payload to update the assignment of multiple service teams to multiple client organizations
 * @export
 * @interface UpdateServiceTeamsToClientsAssignmentRequest
 */
export interface UpdateServiceTeamsToClientsAssignmentRequest {
	/**
	 * The RIDs of the clients to update service teams for
	 * @type {Array<string>}
	 * @memberof UpdateServiceTeamsToClientsAssignmentRequest
	 */
	clientRIDs: Array<string>;
	/**
	 * The RIDs of the service teams to update for the clients
	 * @type {Array<string>}
	 * @memberof UpdateServiceTeamsToClientsAssignmentRequest
	 */
	serviceTeamRIDs: Array<string>;
}

/**
 * Check if a given object implements the UpdateServiceTeamsToClientsAssignmentRequest interface.
 */
export function instanceOfUpdateServiceTeamsToClientsAssignmentRequest(
	value: object
): boolean {
	let isInstance = true;
	isInstance = isInstance && 'clientRIDs' in value;
	isInstance = isInstance && 'serviceTeamRIDs' in value;

	return isInstance;
}

export function UpdateServiceTeamsToClientsAssignmentRequestFromJSON(
	json: any
): UpdateServiceTeamsToClientsAssignmentRequest {
	return UpdateServiceTeamsToClientsAssignmentRequestFromJSONTyped(json, false);
}

export function UpdateServiceTeamsToClientsAssignmentRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): UpdateServiceTeamsToClientsAssignmentRequest {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		clientRIDs: json['clientRIDs'],
		serviceTeamRIDs: json['serviceTeamRIDs'],
	};
}

export function UpdateServiceTeamsToClientsAssignmentRequestToJSON(
	value?: UpdateServiceTeamsToClientsAssignmentRequest | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		clientRIDs: value.clientRIDs,
		serviceTeamRIDs: value.serviceTeamRIDs,
	};
}
